// extracted by mini-css-extract-plugin
export var avatar = "_o9-3";
export var avatarContainer = "_o9-2";
export var avatarSpacer = "_o9-5";
export var avatarSpacerContainer = "_o9-4";
export var avatarStackContainer = "_o9-1";
export var bubble = "_o9-0";
export var remainderBubble = "_o9-6";